import { isSupabaseEnabled, supabase } from './supabaseClient';

export async function fetchUserProfile(email) {
  if (!email || !isSupabaseEnabled()) {
    return { displayName: '', avatarUrl: '' };
  }

  const { data, error } = await supabase.rpc('get_admin_profile', {
    p_email: email.trim().toLowerCase(),
  });

  if (error) {
    console.error('Failed to fetch user profile:', error);
    return { displayName: '', avatarUrl: '' };
  }

  const row = Array.isArray(data) ? data[0] : data;

  return {
    displayName: row?.display_name || '',
    avatarUrl: row?.avatar_url || '',
  };
}

export async function updateUserPassword(email, currentPassword, newPassword) {
  if (!isSupabaseEnabled()) {
    return { ok: false, error: 'Profile settings require Supabase.' };
  }

  if (!newPassword || newPassword.length < 8) {
    return { ok: false, error: 'New password must be at least 8 characters.' };
  }

  const { data, error } = await supabase.rpc('update_admin_password', {
    p_email: email.trim().toLowerCase(),
    p_current_password: currentPassword,
    p_new_password: newPassword,
  });

  if (error) {
    console.error('Failed to update password:', error);
    return { ok: false, error: 'Could not update password. Please try again.' };
  }

  if (!data) {
    return { ok: false, error: 'Current password is incorrect.' };
  }

  return { ok: true };
}

export async function updateUserProfile(email, { displayName, avatarUrl }) {
  if (!isSupabaseEnabled()) {
    return { ok: false, error: 'Profile settings require Supabase.' };
  }

  const { data, error } = await supabase.rpc('update_admin_profile', {
    p_email: email.trim().toLowerCase(),
    p_display_name: displayName ?? '',
    p_avatar_url: avatarUrl ?? '',
  });

  if (error) {
    console.error('Failed to update profile:', error);
    const message = error.message || '';
    if (/payload|too large|entity too large/i.test(message)) {
      return { ok: false, error: 'Photo must be under 2 MB. Try a smaller image.' };
    }
    return { ok: false, error: 'Could not update profile. Please try again.' };
  }

  if (!data) {
    return { ok: false, error: 'Could not update profile. Please try again.' };
  }

  return { ok: true };
}
